import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/history/page.js");
